import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPlaylist } from '../../redux/playlist';
import { makeStyles } from '@material-ui/core/styles';
import { playNow } from '../../redux/draft';
import PlayItem from './PlayItem';

const Playlist = ({ onPlayNow }) => {
  const playlist = useSelector((state) => state.playlist);
  const timecard = useSelector((state) => state.timecard);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPlaylist());
  }, [timecard]);

  const playNowClick = (item, type) => {
    if (!onPlayNow) dispatch(playNow(item, timecard.timecardId, type));
    else onPlayNow(item, type);
  };

  if (!playlist.length || !timecard) return '';
  return (
    <Grid spacing={1} container style={{ maxWidth: '100%', margin: 0 }}>
      {playlist.map((item, index) => {
        return (
          <Grid
            xs={12}
            item
            key={item.taskId}
            style={{ cursor: 'pointer' }}
            onClick={() => playNowClick({ ...item, description: '' }, 'play')}
          >
            <PlayItem item={item} onResume={() => playNowClick(item, 'resume')} />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default Playlist;
